import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Collapse,
  FormControl,
  MenuItem,
  InputLabel,
  Select,
} from "@material-ui/core";
import AutoCompleteSelect from "components/Select";
import Cookie from "universal-cookie";
import "./style.css"
import { useSelector } from "react-redux";
const cookie = new Cookie();
const profile = cookie.get("profile_cookie");
const HirarkiForm = (props) => {
  let {
    classes,
    periode,
    type,
    onChangeSub,
    hirarkiIndex1,
    hirarkiIndex2,
    hirarkiIndex3,
    detail,
    is_edited,
    mcb,
    isDetail,
  } = props;
  const [keterangan, setketerangan] = useState(detail?.keterangan);
  const [durasiErrorMessage, setDurasiErrorMessage] = useState('');
  const [durasi, setDurasi] = useState(detail?.durasi);
  const [periodeValue, setPeriodeValue] = useState(detail?.periode || null);
  const [showPeriodeError, setShowPeriodeError] = useState(false);
  const proyek = useSelector((state) => state.proyek);
  const maxPegawai = Number(localStorage.getItem("max_pegawai")) || 0;
  const showPegawaiError = Number(detail?.pegawai) > maxPegawai;
  useEffect(() => {
    // console.log(`detail?.keterangan`, detail?.keterangan)
    setketerangan(detail?.keterangan);
  }, [detail]);
  useEffect(() => {
    setDurasi(detail?.durasi);
  }, []);
  useEffect(() => {
    if (keterangan) {
      setShowPeriodeError(false);
    }
  }, [keterangan]);
  useEffect(() => {
    if (durasi > 240 && !keterangan ) {
      localStorage.setItem("error", "true");
    } else {
      localStorage.setItem("error", "false");

    }
  }, [keterangan, durasi]);
  useEffect(() => {
    if (detail?.pegawai > maxPegawai ) {
      localStorage.setItem("errorPegawai", "true");
    } else {
      localStorage.setItem("errorPegawai", "false");

    }
  }, [showPegawaiError]);
  const handleDurasiChange = (e) => {
    const value = e.target.value;
    setDurasi(value);

    // Check for error condition
    if (value > 240) {
      localStorage.setItem("error", "true");
      setDurasiErrorMessage('*Apabila durasi pengerjaan lebih dari 240 menit, rincikan formula dari mana durasi itu didapatkan. Misalnya: Durasi 4800 menit karena dikerjakan 10 hari x 8 jam x 60 menit.');
    } else {
      setDurasiErrorMessage('');
      localStorage.setItem("error", "false");
    }
  };
  const handlePeriodeChange = (event, value) => {
    setPeriodeValue(value);

    // If "N/A" is selected, show the error if no keterangan is provided
    if (value?.id === 7) {
      setShowPeriodeError(true);
      localStorage.setItem("errorPegawai", "true"); // Show error if "N/A" and no keterangan
    } else {
      setShowPeriodeError(false);
      localStorage.setItem("errorPegawai", "true"); // Clear error otherwise
    }

    // Trigger your existing onChangeSub
    onChangeSub("periode", value, hirarkiIndex1, hirarkiIndex2, hirarkiIndex3);
  };
  let periodes = [
    { id: 1, text: "Harian", value: 228 },
    { id: 2, text: "Mingguan", value: 52 },
    { id: 3, text: "Bulanan", value: 12 },
    { id: 4, text: "Triwulanan", value: 4 },
    { id: 5, text: "Semesteran", value: 2 },
    { id: 6, text: "Tahunan", value: 1 },
    { id: 7, text: "N/A", value: 0 },
  ];
  let findPeriodeText = (periode) => {
    if (periode !== null) {
      if (proyek.recap_detail !== null && periode?.id === 1) {
        return {
          id: 1,
          text: "Harian",
          value: proyek.recap_detail?.wke.annualWorkingDays,
        };
      } else {
        let filter = periodes.filter((f) => {
          return f.id === periode?.id;
        });
        if (filter.length > 0) {
          return filter[0];
        } else {
          return { id: 0, text: "" };
        }
      }
    } else {
      return { id: 0, text: "" };
    }
  };
  // let total_beban_kerja=detail.periode.id===1?proyek.recap_detail.wke.annualWorkingDays:findPeriodeText(detail.periode).value*detail.kuantitas*detail.durasi*detail.pegawai
  let total_beban_kerja =
    findPeriodeText(detail?.periode).value *
    detail?.kuantitas *
    detail?.durasi *
    detail?.pegawai;
  // console.log('kk',findPeriodeText(detail.periode),detail.periode)
  // console.log("props", mcb);
  return (
    <>
      {mcb === true ? (
        <div style={{ width: "93%", marginBottom: 20 }}>
          <div className="div-flex" style={{ marginBottom: 10 }}>
            <div>
              <TextField
                disabled={!is_edited}
                label="Beban Kerja"
                variant="outlined"
                type="number"
                placeholder="0"
                value={detail?.bebanKerja}
                size="small"
                className={classes.textField}
                onChange={(e) =>
                  onChangeSub(
                    "bebanKerja",
                    e.target.value,
                    hirarkiIndex1,
                    hirarkiIndex2,
                    hirarkiIndex3
                  )
                }
              />
              &nbsp;&nbsp;&nbsp;
              <TextField
                disabled={!is_edited}
                label="Satuan Beban Kerja"
                variant="outlined"
                type="text"
                placeholder="Satuan Beban Kerja"
                value={detail?.satuanBebanKerja}
                size="small"
                className={classes.textField}
                onChange={(e) =>
                  onChangeSub(
                    "satuanBebanKerja",
                    e.target.value,
                    hirarkiIndex1,
                    hirarkiIndex2,
                    hirarkiIndex3
                  )
                }
              />
            </div>
            &nbsp;&nbsp;&nbsp;
            <div>
              <TextField
                disabled={!is_edited}
                label="Standard Kemampuan Rata-Rata"
                variant="outlined"
                type="number"
                placeholder="0"
                value={detail?.skr}
                size="small"
                className={classes.textField}
                onChange={(e) =>
                  onChangeSub(
                    "skr",
                    e.target.value,
                    hirarkiIndex1,
                    hirarkiIndex2,
                    hirarkiIndex3
                  )
                }
              />
              &nbsp;&nbsp;&nbsp;
              <TextField
                disabled={!is_edited}
                label="Satuan SKR"
                variant="outlined"
                type="text"
                placeholder="Satuan SKR"
                value={detail?.satuanSKR}
                size="small"
                className={classes.textField}
                onChange={(e) =>
                  onChangeSub(
                    "satuanSKR",
                    e.target.value,
                    hirarkiIndex1,
                    hirarkiIndex2,
                    hirarkiIndex3
                  )
                }
              />
            </div>
            &nbsp;&nbsp;&nbsp;
            <div>
              <TextField
                disabled
                label="Waktu Penyelesaian Tugas"
                variant="outlined"
                type="number"
                placeholder="0"
                value={detail?.wpt}
                size="small"
                className={classes.textField}
                onChange={(e) =>
                  onChangeSub(
                    "wpt",
                    e.target.value,
                    hirarkiIndex1,
                    hirarkiIndex2,
                    hirarkiIndex3
                  )
                }
              />
              &nbsp;&nbsp;&nbsp;
              <TextField
                disabled={!is_edited}
                label="Satuan WPT"
                variant="outlined"
                type="text"
                placeholder="Satuan WPT"
                value={detail?.satuanWPT}
                size="small"
                className={classes.textField}
                onChange={(e) =>
                  onChangeSub(
                    "satuanWPT",
                    e.target.value,
                    hirarkiIndex1,
                    hirarkiIndex2,
                    hirarkiIndex3
                  )
                }
              />
            </div>
          </div>
        </div>
      ) : (
        <div style={{ width: "93%", marginBottom: 20 }}>
          <div className="div-flex" style={{ marginBottom: 10 }}>
            <div

              style={{ width: 500 }}
              data-tip="- Tugas utama (Sesuai Jobdesc)
- Tugas berkala/proyek (Tahun depan mungkin tidak ada / berbeda)
- Tugas tambahan (Diluar Jobdesc)"
            >
              <AutoCompleteSelect
                onChange={(event, value) =>
                  onChangeSub(
                    "jenis_tugas",
                    value,
                    hirarkiIndex1,
                    hirarkiIndex2,
                    hirarkiIndex3
                  )
                }
                options={type}
                value={detail?.jenis_tugas}
                getOptionLabel={(option) => option.text}
                getOptionSelected={(opt, value) => opt.text}
                label={<>Jenis Tugas</>}
                disableClearable
                disabled={!is_edited}
              />
            </div>
            &nbsp;&nbsp;&nbsp;
              <div
                style={{ width: 450 }}
                data-tip="Periode Frekuensi pekerjaan, apakah dilakukan harian, mingguan, bulanan, tahunan, dst. Pastikan pekerjaan tersebut pasti ada selama periode tersebut."
              >
                <AutoCompleteSelect
                  onChange={handlePeriodeChange}
                  options={periode}
                  value={periodeValue}
                  getOptionLabel={(option) => option.text}
                  getOptionSelected={(opt, value) => opt.text === value.text}
                  label="Periode"
                  disableClearable
                  disabled={!is_edited}
                  style={{
                    borderColor: showPeriodeError ? 'red' : '', // Change border color on error
                    color: showPeriodeError ? 'red' : '', // Change text color on error
                  }}
                  className={showPeriodeError ? 'error-text-field' : ''} // Apply error class
                />
              </div>
            &nbsp;&nbsp;&nbsp;
            <div
              style={{ width: 340 }}
              data-tip="Jumlah Output / Kuantitas pekerjaan yang Dihasilkan dalam satu periode. Misal jika periode harian, maka Qty ditulis kuantitas kerja selama 1 hari."
            >
              <TextField

                disabled={!is_edited}
                label="Kuantitas"
                variant="outlined"
                type="number"
                placeholder="0"
                value={detail?.kuantitas}
                size="small"
                className={classes.textField}
                onChange={(e) =>
                  onChangeSub(
                    "kuantitas",
                    e.target.value,
                    hirarkiIndex1,
                    hirarkiIndex2,
                    hirarkiIndex3
                  )
                }
              />
            </div>

            &nbsp;&nbsp;&nbsp;
            <div
              style={{ width: 840 }}
              data-tip="Lama pelaksanaan kegiatan rata-rata yang dilakukan pada setiap quantity. Penulisan disini TIDAK perlu dikalikan dengan Qty karena akan dikalikan sistem."
            >
              <TextField
                disabled={!is_edited}
                label="Durasi pengerjaan (menit)"
                variant="outlined"
                type="number"
                placeholder="0"
                value={durasi}
                size="small"
                className={`${classes.textField} ${(durasi > 240 && !keterangan) ? 'error-text-field' : ''}`}
                onChange={handleDurasiChange}
                onBlur={() =>
                  onChangeSub(
                    "durasi",
                    durasi,
                    hirarkiIndex1,
                    hirarkiIndex2,
                    hirarkiIndex3
                  )
                }
                inputProps={{
                  max: 240,
                }}
                style={{
                  borderColor: durasi > 240 && !keterangan ? 'red' : '',
                  color: durasi > 240 && !keterangan ? 'red' : '',
                }}
              />
            </div>

            &nbsp;&nbsp;&nbsp;
            <div
              style={{ width: 700 }}
              data-tip="Jumlah Orang/Personil dengan jabatan yang sama untuk Melakukan Suatu Kegiatan Pada Waktu yang Sama (tidak bergantian)"
            >
              <TextField
                style={{
                  width: profile.roleId !== 5 ? "80%" : undefined, borderColor: showPegawaiError ? 'red' : '',
                  color: showPegawaiError ? 'red' : '',
                  width: profile.roleId !== 5 ? "80%" : undefined,
                }}
                disabled={!is_edited}
                label="Jml pegawai terlibat"
                variant="outlined"
                type="number"
                placeholder="0"
                value={detail?.pegawai}
                size="small"
                className={`${classes.textField} ${showPegawaiError ? 'error-text-field' : ''}`}
                inputProps={{
                  max: maxPegawai,
                }}
                
                onChange={(e) =>
                  onChangeSub(
                    "pegawai",
                    e.target.value,
                    hirarkiIndex1,
                    hirarkiIndex2,
                    hirarkiIndex3
                  )
                }
                
              />
            </div>

            

            {profile.roleId !== 5 && (
              <>
                <TextField
                  error={total_beban_kerja > 50000 ? true : false}
                  style={{ width: 400 }}
                  disabled={true}
                  label="Beban Kerja"
                  variant="outlined"
                  type="text"
                  value={
                    Number.isNaN(total_beban_kerja)
                      ? "-"
                      : total_beban_kerja.toLocaleString()
                  }
                  size="small"
                  InputProps={{
                    classes: {
                      root:
                        total_beban_kerja > 50000
                          ? classes.root
                          : classes.root2,
                      disabled: classes.disabled,
                      notchedOutline: classes.notchedOutline,
                    },
                  }}
                  onChange={(e) =>
                    onChangeSub(
                      "pegawai",
                      e.target.value,
                      hirarkiIndex1,
                      hirarkiIndex2,
                      hirarkiIndex3
                    )
                  }
                />
              </>
            )}

          </div>
          <div>
            <TextField
              label="Keterangan"
              variant="outlined"
              disabled={!is_edited}
              value={keterangan}
              size="small"
              multiline
              className={classes.textField}
              onChange={(e) => setketerangan(e.target.value)}
              onBlur={(e) =>
                onChangeSub(
                  "keterangan",
                  keterangan,
                  hirarkiIndex1,
                  hirarkiIndex2,
                  hirarkiIndex3
                )
              }
            />
          </div>

          {(durasi > 240 && !keterangan) && (
            <div style={{ color: 'red', fontSize: '12px', marginTop: "1rem" }}>
              {durasiErrorMessage}
            </div>
          )}
          {showPegawaiError && (
            <div style={{ color: 'red', fontSize: '12px', marginTop: "1rem" }}>
              *Jumlah pegawai terlibat tidak boleh melebihi jumlah pegawai sesuai pengisian di info data diri (halaman setelah login). Contoh 1: Untuk staf admin dengan total staf 2 orang, jumlah pegawai terlibat tidak lebih dari 2 orang.
            </div>
          )}
            {(showPeriodeError  && !keterangan) && (
              <div style={{ color: 'red', fontSize: '12px', marginTop: '1rem' }}>
                *Apabila Aktivitas atau proses kerja sengaja dikosongkan, tuliskan alasannya di keterangan. Misalnya karena pekerjaan tidak dilakukan, ataupun sudah terwakilkan di proses kerja sebelumnya.
              </div>
            )}
        </div>
      )}
    </>
  );
};

export default HirarkiForm;
